import { ISelect } from './../../store/models/select.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-insert-hyperlink',
  templateUrl: './insert-hyperlink.component.html',
  styleUrls: ['./insert-hyperlink.component.scss'],
})
export class InsertHyperlinkComponent implements OnInit {
  @Input() inputForm: FormGroup;

  selectTargetProperties: ISelect<any> = {
    label: 'Select target...',
    items: [
      {
        label: 'Blank (a new window or tab)',
        value: '_blank',
      },
      {
        label: 'Self (the same window or tab)',
        value: '_self',
      },
    ],
  };

  constructor() {}

  ngOnInit() {
    this.inputForm.addControl(
      'content',
      new FormControl('', [Validators.required])
    );
    this.inputForm.addControl(
      'url',
      new FormControl('', [Validators.required])
    );
    this.inputForm.addControl('target', new FormControl('_blank'));
  }
}
